import React, { useState } from "react";
import styles from "./Product.module.css";
import ProductCard from "../Products/ProductCard";
import { ICategorySectionProps } from "@model/Products.model";
import Chevron from "Utils/Assets/SVGs/Chevron";
import useImageUploadRules from "../../../Logic/Functions/Hooks/useImageUploadRules";

const CategorySection: React.FC<ICategorySectionProps> = ({
  title,
  description,
  products,
  defaultExpanded = true,
  CustomclassName = "",
}) => {
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded);

  const { buildImageSrc } = useImageUploadRules({
    maxFiles: 1,
    maxSizeMB: 5,
    requireAtLeastOne: false,
    enforceTotalSize: false,
  });

  return (
    <section className={`${styles.section} ${CustomclassName}`} data-testid="category-section">
      <div className={styles.collapseBox}>
        <button
          type="button"
          className={styles.collapseHeader}
          aria-expanded={expanded}
          onClick={() => setExpanded((e) => !e)}
          data-testid="category-toggle"
        >
          <Chevron className={styles.chevron} data-expanded={expanded || undefined} />
          <h2 className={styles.collapseTitle} data-testid="category-title">
            {title}
          </h2>
        </button>

        {description && (
          <p className={styles.descriptionp} data-testid="category-description">
            {description}
          </p>
        )}
        <div

          className={`${styles.collapseBody} ${expanded ? styles.open : styles.closed}`}
          aria-hidden={!expanded}
          data-testid="category-panel"
        >
          <div className={styles.collapseInner}>


            <div className={styles.cardsWrap} data-testid="category-grid">
              {products?.length ? (
                products.map((p: any) => {
                  const firstRaw =
                    Array.isArray(p?.images) && p.images.length
                      ? (typeof p.images[0] === "string" ? p.images[0] : p.images[0]?.url)
                      : p?.imageUrl;

                  const normalized = buildImageSrc(firstRaw ?? null) ?? "";

                  return <ProductCard key={p.id} {...p} imageUrl={normalized} />;
                })
              ) : (
                <div className={styles.empty} data-testid="category-empty">
                  No products in this category.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
